// import AnalyticsInfo from '@/features/finances/components/Analytics/AnalyticsInfo/AnalyticsInfo';
// import BalanceInfo from '@/features/finances/components/Balance/BalanceInfo';
import TransactionsInfo from '@/features/finances/components/Transactions/TransactionsInfo/TransactionsInfo';
import { FC } from 'react';

type Props = {
	ownerId: string;
	isMobile?: boolean;
};

const OwnerDetailsListFinances: FC<Props> = ({ ownerId, isMobile }) => {
	return (
		<div className='h-full flex flex-col gap-6 select-none'>
			{/*<AnalyticsInfo />*/}
			{/*<BalanceInfo showPayButtons={false} />*/}
			<TransactionsInfo isMobile={isMobile} ownerId={ownerId} />
		</div>
	);
};

export default OwnerDetailsListFinances;
